import { render, staticRenderFns } from "./datatable-pt.vue?vue&type=template&id=77641dc2&"
import script from "./datatable-pt.vue?vue&type=script&lang=js&"
export * from "./datatable-pt.vue?vue&type=script&lang=js&"
import style0 from "./datatable-pt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports